// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","261": "4752969116ed","3616": "2bd20f1d2224","4004": "66f2b799903c","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}